/* Quantity stepper — the control's own arithmetic, and nothing else.
   It changes its input within min/max/step and emits the native events a form
   already understands. Cart mutation is Phase 7's, and must stay there. */
class EmoreQty extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('.qty__input');
    if (!this.input) return;
    this.addEventListener('click', this.onClick);
    this.input.addEventListener('change', () => this.clamp());
    this.sync();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  onClick = (event) => {
    const button = event.target.closest('[data-qty-step]');
    if (!button || button.disabled) return;
    const step = Number(this.input.step || 1) * Number(button.dataset.qtyStep);
    this.set(Number(this.input.value || 0) + step);
  };

  set(next) {
    const before = this.input.value;
    this.input.value = String(this.bounded(next));
    if (this.input.value === before) return;
    this.input.dispatchEvent(new Event('input', { bubbles: true }));
    this.input.dispatchEvent(new Event('change', { bubbles: true }));
    this.sync();
  }

  clamp() {
    this.input.value = String(this.bounded(Number(this.input.value)));
    this.sync();
  }

  bounded(value) {
    const min = this.input.min === '' ? 1 : Number(this.input.min);
    const max = this.input.max === '' ? Infinity : Number(this.input.max);
    if (!Number.isFinite(value)) return min;
    return Math.min(max, Math.max(min, Math.round(value)));
  }

  /* A step that cannot move is disabled rather than silently inert. */
  sync() {
    const value = Number(this.input.value);
    const min = this.input.min === '' ? 1 : Number(this.input.min);
    const max = this.input.max === '' ? Infinity : Number(this.input.max);
    const down = this.querySelector('[data-qty-step="-1"]');
    const up = this.querySelector('[data-qty-step="1"]');
    if (down) down.disabled = value <= min;
    if (up) up.disabled = value >= max;
  }
}

if (!customElements.get('emore-qty')) customElements.define('emore-qty', EmoreQty);
